var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#2B55EF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7013 4.64967C11.5181 4.83659 11.4155 5.08791 11.4155 5.34967C11.4155 5.61142 11.5181 5.86274 11.7013 6.04967L13.3013 7.64967C13.4882 7.83289 13.7396 7.93552 14.0013 7.93552C14.2631 7.93552 14.5144 7.83289 14.7013 7.64967L18.4713 3.87967C18.9742 4.99085 19.1264 6.2289 18.9078 7.42881C18.6892 8.62872 18.11 9.73351 17.2476 10.5959C16.3852 11.4584 15.2804 12.0375 14.0805 12.2561C12.8806 12.4748 11.6425 12.3225 10.5313 11.8197L3.62132 18.7297C3.2235 19.1275 2.68393 19.351 2.12132 19.351C1.55871 19.351 1.01915 19.1275 0.62132 18.7297C0.223496 18.3318 0 17.7923 0 17.2297C0 16.6671 0.223496 16.1275 0.62132 15.7297L7.53132 8.81967C7.02848 7.70848 6.87624 6.47043 7.09486 5.27052C7.31349 4.07061 7.89261 2.96582 8.75504 2.10339C9.61748 1.24095 10.7223 0.661834 11.9222 0.443208C13.1221 0.224581 14.3601 0.37683 15.4713 0.879665L11.7113 4.63967L11.7013 4.64967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.2067952f8f6c0666c6cd8eaf177e1ff0.svg";
export { ForwardRef as ReactComponent };